<table>
    <tbody>
        <tr>
            <td>{{ i18n._7146_METRIC_NAME | translate }}</td>
            <td>{{ metric?.shortName }}</td>
        </tr>
        <ng-container *ngFor="let i of supportedColumns">
            <tr [ngSwitch]="i.id">
                <td>{{ i.name }}</td>
                <ng-container *ngSwitchCase="OptionalColumnType.CURRENT_ACTUAL">
                    <td>
                        <span
                            [ngClass]="{
                                'insight-metric-bold':
                                    showThresholdColours &&
                                    dataMetric?.targetThresholdBold
                            }"
                            [ngStyle]="{
                                color:
                                    showThresholdColours &&
                                    dataMetric?.targetThresholdColor
                            }"
                            >{{ formatColumn(i.id) }}</span
                        >
                        <ng-container *ngIf="showThresholdColours">
                            <span class="sr-only">{{
                                dataMetric?.targetThresholdName
                            }}</span>
                        </ng-container>
                        <ng-container
                            *ngIf="showTrendArrows && dataMetric?.trendClass"
                        >
                            <cmps-icon
                                [style.fill]="
                                    dataMetric.trendClass.split(' ')[0]
                                "
                                [svgIcon]="dataMetric.trendClass.split(' ')[1]"
                                *ngIf="
                                    dataMetric?.trendClass?.split(' ')?.length >
                                    1
                                "
                            ></cmps-icon>
                            <span class="sr-only">{{
                                dataMetric?.trendName
                            }}</span>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <td>{{ formatColumn(i.id) }}</td>
                </ng-container>
            </tr>
        </ng-container>
    </tbody>
</table>
